(() => {
  const init = root => {
    if (root.dataset.extrasInitialized) return;
    root.dataset.extrasInitialized = 'true';
    const form = root.querySelector('[data-coffin-form], [data-cocada-form]');
    const fields = [...form.querySelectorAll('[data-halloween-extra]')];
    if (!fields.length) return;
    const total = root.querySelector('[data-coffin-total], [data-cocada-total]');
    const money = new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency });
    const selected = () => fields.filter(field => Number(field.value) > 0);
    const update = () => {
      const extras = fields.reduce((sum, field) => sum + Math.max(0, Number(field.value) || 0) * Number(field.dataset.extraPrice), 0);
      total.textContent = money.format((Number(root.dataset.price) + extras) * Math.max(1, Number(form.elements.quantity.value) || 1) / 100);
    };
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', async event => {
      if (event.defaultPrevented || root.dataset.preview === 'true' || !selected().length) return;
      event.preventDefault();
      update();
      if (form.dataset.extrasSubmitting === 'true') return;
      if (!form.reportValidity()) return;
      form.dataset.extrasSubmitting = 'true';
      const button = form.querySelector('button[type="submit"]');
      const error = root.querySelector('[data-halloween-extra-error]');
      error.hidden = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const data = new FormData(form);
      const quantity = Number(data.get('quantity')) || 1;
      const properties = {};
      for (const [name, value] of data.entries()) {
        const match = name.match(/^properties\[(.*)\]$/);
        if (match) properties[match[1]] = String(value);
      }
      const group = crypto.randomUUID();
      properties._emma_halloween_group = group;
      const items = [{ id: Number(data.get('id')), quantity, properties }];
      selected().forEach(field => {
        const panel = field.closest('[data-coffin], [data-cocada-coffin]');
        const extraProperties = {
          'For product': root.dataset.bundleTitle,
          'Coffin': field.dataset.extraCoffin,
          'Coffin color': data.get('properties[Coffin ' + field.dataset.extraCoffin + ' color]'),
          '_emma_halloween_group': group
        };
        if (field.dataset.halloweenExtra === 'chamoy') {
          extraProperties['Chamoy flavor'] = panel.querySelector('[data-chamoy]:checked').value;
          extraProperties['Spice level'] = panel.querySelector('[data-heat]:checked').value;
          extraProperties['Extra chamoy'] = 'Yes';
        } else {
          extraProperties['Cocada flavor'] = panel.querySelector('[data-cocada-flavor]:checked').value;
          extraProperties['Extra syrup'] = 'Yes';
        }
        items.push({ id: Number(field.dataset.extraVariant), quantity: Number(field.value) * quantity, properties: extraProperties });
      });
      try {
        const response = await fetch(root.dataset.cartAddUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart add failed');
        window.location.assign(root.dataset.cartUrl);
      } catch {
        error.hidden = false;
        error.focus();
        button.disabled = false;
        button.removeAttribute('aria-busy');
        delete form.dataset.extrasSubmitting;
      }
    });
    fields.forEach(field => field.disabled = false);
    update();
  };
  const start = () => document.querySelectorAll('[data-halloween-builder], [data-halloween-cocadas], [data-halloween-mixed]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
